import React from "react"
import { graphql } from "gatsby"
import Layout from "./layout-2"




const IndexPage = ({ data }) => {


return (

    <Layout>
       <div className="col">
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <div key={node.id} class="list col-6">
              <div  dangerouslySetInnerHTML={{ __html: node.html }} />
            </div>
        ))}
        </div>
        {/* <div className="col">
            <h2>Class Resources</h2>
            <div class="list col-6">
              <ul>
                <li><a href="https://docs.google.com/document/d/1vk6vJiTXhBOPzLV6Qt5Xkc3Q-IgyIl4uN5zsw0bEttY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Github: Getting Started</a></li>
                <li><a href="https://www.are.na/minkyoung-kim/graph-3237-graphic-design-for-the-web"  target="_blank" rel="noopener noreferrer">Class Are.na</a></li>
                <li><a href="https://docs.google.com/document/d/1ftr9bcggip-5Kguep98DiySpr33zdUnixYztmmcycEs/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></li>
                <li><a href="https://docs.google.com/presentation/d/13GiTimrQ8OSrmqluseu49eS1m1xPkdOi17d4kq5HfMY/edit?usp=sharing" target="_blank"  rel="noopener noreferrer">HTML Basics and Setup</a></li>
                <li><a href="https://docs.google.com/presentation/d/1oD15PI9jLSUh7YTtO8L_ORQuEH6wG1dGjaN5el58Aog/edit?usp=sharing" target="_blank" rel="noopener noreferrer">How the Internet Works & How to Stay Organized</a></li>
              </ul>
          </div>
        </div> */}
    </Layout>
  )
}

export default IndexPage




export const query = graphql`
  query {
    allMarkdownRemark(
        sort: { fields: [frontmatter___date], order:ASC } 
        filter: {fileAbsolutePath: {regex: "/wam1f26/_resources/.*.md$/"}}
        ) {
      totalCount
      edges {
        node {
          html
          id
          frontmatter {
            title
            date
          }
          fields {
            slug
          }
        }
      }
    }
  }
`